<div class="user-name">
    <div class="name">{{user?.name}}</div>
    <img src={{user_icon}} alt="">
</div>
<div class="user-balance">
    <div class="balance">{{user?.balance}}</div>
    <img src={{eye_icon}} alt="">
</div>

